export default __webpack_public_path__ + "static/media/economic2.298bf9fe.jpg";